import { 
  GetShippingCarriers,
  CreateShippingCarrier,
  UpdateShippingCarrier,
  RemoveShippingCarrier,
  ShippingInfo,
  GetAvailableCarriers,
  GetShippingRates,
  TrackShipping,
  CustomerTrackShipping
} from '@/api/shipping';

// eslint-disable-next-line import/no-cycle

export const getShipping = ({dispatch}) => dispatch('CheckAuth', null, {root: true})
  .then(() => GetShippingCarriers()
    .then(res => {
      return res.shipping_carriers;
    })
  )
  .catch((e) => {
    console.log(e);
  });

export const connectShippingService = ({dispatch}, data) => dispatch('CheckAuth', null, {root: true})
  .then(() => CreateShippingCarrier(data)
    .then(res => {
      return res;
    })
  )
  .catch((e) => {
    console.log(e);
  });

export const updateShippingService = ({dispatch}, data) => dispatch('CheckAuth', null, {root: true})
  .then(() => UpdateShippingCarrier(data)
    .then(res => {
      return res;
    })
  )
  .catch((e) => {
    console.log(e);
  });

export const removeShippingService = ({dispatch}, provider) => dispatch('CheckAuth', null, {root: true})
  .then(() => RemoveShippingCarrier(provider)
    .then(res => {
      return res;
    })
  )
  .catch((e) => {
    console.log(e);
  });

export const getShippingInfo = ({dispatch}, data) => dispatch('CheckAuth', null, {root: true})
  .then(() => ShippingInfo(data)
    .then(res => {
      return res;
    })
  )
  .catch(e => new Promise((resolve, reject) => {
    reject(e);
  }));

export const getShippingCarriers = ({dispatch}) => dispatch('CheckAuth', null, {root: true})
  .then(() => GetAvailableCarriers()
    .then(res => {
      return res;
    })
  )
  .catch((e) => {
    console.log(e);
  });

export const getShippingRates = ({dispatch}, data) => dispatch('CheckAuth', null, {root: true})
  .then(() => GetShippingRates(data)
    .then(res => {
      return res;
    })
  )
  .catch(e => new Promise((resolve, reject) => {
    reject(e);
  }));

export const trackShipping = ({dispatch}, mail_id) => dispatch('CheckAuth', null, {root: true})
  .then(() => TrackShipping(mail_id)
    .then(res => {
      return res;
    })
  )
  .catch((e) => {
    console.log(e);
  });


  export const customerTrackShipping = ({dispatch}, mail_id) => dispatch('CheckAuth', null, {root: true})
  .then(() => CustomerTrackShipping(mail_id)
    .then(res => {
      return res;
    })
  )
  .catch((e) => {
    console.log(e);
  });